<script setup>
import { ref, onMounted, reactive, computed } from 'vue';
import * as routeFunctions from '@/helpers/routeFunctions.js';
import { router } from '@/routes/router';
import { useRoute } from 'vue-router';
import { debugLog } from '@/helpers/loggingFunctions.js';
import { useScrollbarDetection } from '@/helpers/pqFlow';

import AuthenticatedLayout from '@/views/layouts/authenticated.vue';
import UnAuthenticatedLayout from '@/views/layouts/unauthenticated.vue';

const getRoute = computed(() => {
    const route = useRoute();
    return route;
});

// lifecycle hooks
onMounted(() => {
    // debugLog('view app.vue mounted triggered')
    useScrollbarDetection();
});
</script>

<template>
    <UnAuthenticatedLayout v-if="getRoute.meta.layout == 'unauthenticated'" />
    <AuthenticatedLayout v-if="getRoute.meta.layout == 'authenticated'" />
</template>
